<template>
  <wt-dropdown-view
    ref="ddView"
    :box-offset="boxOffset"
    :type="position"
    class="-lightbox-wrapper"
    :show-arrow="true"
    :auto-height="autoHeight"
  >
    <template slot="label">
      <div v-if="label">{{ label }}</div>
      <template v-else>
        <wt-svg-animation
          name="lightbox-clapper"
          :scene="scene"
          title="Selected Media"
        />
        <transition name="wt2-fade-fast">
          <span class="-lightbox-count-badge" v-show="selectedAssets.length">{{
            selectedAssets.length
          }}</span>
        </transition>
      </template>
    </template>
    <template slot="view">
      <slot><div class="wt2-text-xl -title">Selected Media</div></slot>
      <div class="-lightbox-padding tooltip-container">
        <wt-lightbox
          :filter="filter"
          :show-uploading="showUploading"
          :show-actions="showActions"
          :can-add="true"
          :media-co-assets="mediaCoAssets"
          :custom-overlay-mode="customOverlayMode"
          :selected="selected"
          @preview-asset="previewAsset"
          @add-asset="addAsset"
        >
          <template v-slot:empty>
            <img
              src="/resources/img/empty_lightbox_icon.png"
              alt="empty lightbox icon"
            />
            <div class="-empty-desc">{{ emptyLightboxText }}</div>
          </template>
        </wt-lightbox>
      </div>
    </template>
  </wt-dropdown-view>
</template>

<script>
import wtLightbox from 'components/assets/wtLightbox.component.vue';
import app from 'app';
import storyViewBus from 'v/Story/storyViewBus';

export default {
  name: 'wt-lightbox-dropdown',

  components: {
    wtLightbox,
  },

  props: {
    autoHeight: { type: Boolean, defaultValue: false },
    emptyLightboxText: { type: String, default: '' },
    mediaCoAssets: { type: Array, default: () => [] },
    scene: { type: String, default: 'mounted' },
    label: { type: String, default: '' },
    showUploading: { type: Boolean, default: true },
    showActions: { type: Boolean, default: true },
    customOverlayMode: { type: Boolean, default: false },
    position: { type: String, default: 'right' },
    title: { type: String, default: '' },
    filter: { type: Function, required: false },
    selected: { type: String, default: '' },
    boxOffset: { type: Number, default: 50 },
  },

  computed: {
    selectedAssets() {
      const selectedAssets = app.rootStore.state.story.selectedAssets;
      if (
        Array.isArray(selectedAssets) &&
        selectedAssets.length &&
        this.filter
      ) {
        return selectedAssets.filter(this.filter);
      }
      return selectedAssets;
    },

    hasAssets() {
      return this.selectedAssets.length;
    },
  },

  methods: {
    previewAsset(asset) {
      this.$emit('preview-asset', asset);
      this.$refs.ddView.close();
    },

    addAsset(asset) {
      const assetClone = _.cloneDeep(asset);
      storyViewBus.$emit('svbAppendToTimeline', {
        asset: assetClone,
        visual: true,
      });
    },
  },
};
</script>
